// eslint-disable-next-line import/prefer-default-export
export const SEARCH_TYPE_DATA = [
	{
		label: 'All content',
	},
	{
		label: 'Recipes',
		name: 'post_type',
		value: 'ce_recipe',
	},
	{
		label: 'Chefs / Hosts',
		name: 'post_type',
		value: 'ce_author',
	},
	{
		label: 'Article',
		name: 'post_type',
		value: 'post',
	},
	{
		label: 'Shows',
		name: 'type',
		value: 'shows',
	},
];
